<div class="container-content">
     <div class="col">
          <div class="dialog">No results found. Please try adjusting your 
               search items or broaden your search.
          </div>
          <button class="close-btn" (click)="onClose()">Close</button>
     </div>
</div>
